import { RequestResponsePattern } from "../../../../../types/Request"
import { postApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."
import { setRequestSaveData, setRequestSaveError, setRequestSaveLoading, setRequestSaveMessage } from "../Reducers/ParametroReducer"
import { SendParams } from "../Types/ParametroParams"
import { ParametroType } from "../Types/ParametroType"

export default async function send(apiController: string, dispatch: Function, values: SendParams){
    try {
        dispatch(setRequestSaveLoading())
        
        const endpoint = `${DOMAIN}/${apiController}`

        const data = { 
            sigla: values.sigla,
            descricao: values.descricao,
            minimo: values.minimo,
            maximo: values.maximo,
            incerteza: values.incerteza,
            flagAtivo: values.flagAtivo ? 1 : 0, 
            flagLaboratorio: values.flagLaboratorio,
            idUsuario: values.idUsuario
        }

        const response: RequestResponsePattern<ParametroType> = await postApi({ endpoint, data })

        if(response){
            dispatch(setRequestSaveData(response))
            if(!response.flagErro) dispatch(setRequestSaveData(response))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
        
    } catch (error: any) {
        console.log(error)
        dispatch(setRequestSaveMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestSaveError())
    }
}